import { Descriptions, Row } from "antd";
import getAtribute from "../../../utils/getAtribute";

export function DetailsSecretarioExecutivo({entidade}){
  const timeFormmatted = entidade.dataAtualizacaoSecretario ?
    `${new Date(entidade.dataAtualizacaoSecretario).toLocaleString()}`
    : '';

  return(
    <>
      <Row justify='center' align='middle'>
        <div className="ant-descriptions-title">Secretário Executivo</div>
      </Row>
      <br />
      <Descriptions >
        <Descriptions.Item label="Nome">{getAtribute(entidade, "nomeAutorizadorSecretario")}</Descriptions.Item>
        <Descriptions.Item label="CPF">{getAtribute(entidade, "cpfAutorizadorSecretario")}</Descriptions.Item>
        <Descriptions.Item label="Observação">{getAtribute(entidade, "obsSecretario")}</Descriptions.Item>
        <Descriptions.Item label="Data">{timeFormmatted}</Descriptions.Item>
      </Descriptions>
    </>
  );

}
